__turbopack_context__.v({
  "ad-info-container": "grid-module-scss-module__e8hJxW__ad-info-container",
  "ad-info-override": "grid-module-scss-module__e8hJxW__ad-info-override",
  "description": "grid-module-scss-module__e8hJxW__description",
  "detail-component": "grid-module-scss-module__e8hJxW__detail-component",
  "detail-container": "grid-module-scss-module__e8hJxW__detail-container",
  "gallery": "grid-module-scss-module__e8hJxW__gallery",
  "navigation-detail-container": "grid-module-scss-module__e8hJxW__navigation-detail-container",
  "right-container": "grid-module-scss-module__e8hJxW__right-container",
  "section-divider": "grid-module-scss-module__e8hJxW__section-divider",
  "skyscraper": "grid-module-scss-module__e8hJxW__skyscraper",
  "vehicle-history": "grid-module-scss-module__e8hJxW__vehicle-history",
});
